export function StripHtml(html: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

export function TruncateText(text: string = '', n: number): string {
  if (text.length > n) {
    return text.slice(0, n) + '...';
  }
  return text;
}

export function CapitalizeFirstLetter(text: string): string {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
}